const TransactionArrow = () => (
  <svg
    enable-background="new 0 0 32 32"
    height="32px"
    id="svg2"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    fill="rgb(51, 159, 123)"
  >
    <g id="background">
      <rect fill="none" height="32" width="32"></rect>
    </g>
    <g id="arrow_x5F_full_x5F_right">
      <polygon points="16,2.001 16,10 2,10 2,22 16,22 16,30 30,16  "></polygon>
    </g>
  </svg>
);

export default TransactionArrow;
